/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback } from "react";
import debounce from "lodash/debounce";
import "./SearchBar.css";

interface SearchBarProps {
  onSearch: (query: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [searchText, setSearchText] = useState("");

  const debouncedSearch = useCallback(
    debounce((query: string) => {
      onSearch(query);
    }, 1000),
    []
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    debouncedSearch(value);
  };

  return (
    <div className="search-container">
      <input
        type="text"
        placeholder="Search"
        value={searchText}
        onChange={handleChange}
        className="search-input"
      />
    </div>
  );
};
